import module from 'nominas/finiquito/module.js'

const schema = {
  colaborador: {
    salario_diario: 'number',
    salario_diario_integrado: 'number',
    salario_diario_ordinario: 'number',
    salario_mensual_ordinario: 'number',
    fecha_alta: 'date',
    fecha_baja: 'date',
  },
  nomina: {
    status: {
      pagado: 'boolean',
      timbrado: 'boolean',
    },
  },
}

export class NominasFiniquitoService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador, idFiniquito) {
    return this.$http.get('/api/nominas/finiquitos/finiquito', {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
      },
      schema,
    })
  }
}

module.service('NominasFiniquito', NominasFiniquitoService)



// WEBPACK FOOTER //
// ./src/nominas/finiquito/services/Finiquito.js